/**
 * Cleans up HTML content from the notes editor by removing empty elements
 * and normalizing spacing
 * 
 * @param {string} content - The HTML content to clean
 * @returns {string} The cleaned HTML content
 */
export const cleanNotesContent = (content) => {
  if (!content) return '';
    
  return content
  // Remove paragraphs that are completely empty or only contain whitespace/line breaks
    .replace(/<p>(\s|<br\s*\/?>\s*)*<\/p>/g, '')
  // Clean up multiple spaces
    .replace(/\s{2,}/g, ' ')
  // Clean up spaces before or after paragraph tags
    .replace(/\s*<\/?p>\s*/g, match => match.trim())
  // Ensure proper spacing between content paragraphs
    .replace(/<\/p><p>/g, '</p>\n<p>')
  // Trim any remaining whitespace
    .trim();
};
  
/**
   * Validates notes content before saving
   * 
   * @param {string} content - The content to validate
   * @returns {Object} Object with isValid boolean and any error messages
   */
export const validateNotesContent = (content) => {
  const errors = [];
    
  // Add any validation rules here
    
  return {
    isValid: errors.length === 0,
    errors
  };
};